module.exports = __webpack_public_path__ + "img/portraits_17_V.8cd22e43.webp";